'use strict';

function simpleRepeat(n, fn) {
  for (var i = 0; i < n; i++) {
    fn(i);
  }
}

module.exports = simpleRepeat;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/simpleRepeat.js
// module id = 263
// module chunks = 0